<n-slide-window
    [(visible)]="show"
    [showMask]="false"
    (onShow)="onShow()"
    (onHide)="onHide()"
    [hideOnRouteChange]="false"
    width="1000px">
    <n-header>
        <h1>{{task.displayName}}</h1>
    </n-header>
    <n-lv class="task-detail" [simpleMode]="SWITCH.IS_SIMPLE_MODE">
        <n-lv-item [label]="i18nLabel.object">
            <span [innerHTML]="replaceBlock(task.objName)"></span>
        </n-lv-item>
        <n-lv-item [label]="i18nLabel.taskStatus">
            <div class="interval-5">
                <p-progressBar class="progress-bar"
                    [showValue]=false
                    [value]="task.progress"
                    [color]="str.statusColor[task.taskStatus]">
                </p-progressBar>
                <span *ngIf="task.taskStatus === taskStatus.running || task.taskStatus === taskStatus.rollbacking">
                    {{task.progress}}%
                </span>
                <span>
                    {{statusText[task.taskStatus]}}
                </span>
            </div>
        </n-lv-item>
        <n-lv-item [label]="i18nLabel.creator">{{task.creator}}</n-lv-item>
        <n-lv-item [label]="i18nLabel.startTime">{{renderTime | fn :task.startTime}}</n-lv-item>
        <n-lv-item [label]="i18nLabel.endTime">{{renderTime | fn :task.endTime}}</n-lv-item>
        <n-lv-item [label]="i18nLabel.duration">{{renderDuration | fn :task}}</n-lv-item>
    </n-lv>
    <div class="flex-wrapper">
        <button pButton
            style="margin: 0 0 10px auto"
            class="icon-btn border"
            icon="icon-refresh"
            (click)="onRefresh()"
            id="monitor_task_detail_table_click_refresh">
        </button>
    </div>
    <n-data-table #dt
        *ngIf="show"
        id="monitor_task_detail_table"
        style="height: 400px;"
        [config]="tableConfig"
        [columnDefs]="columnDefs"
        [rest]="dataRest">
        <ng-template nTemplate
            [meta]="{field: 'execStatus'}"
            let-col
            let-value="value"
            let-data="rowData">
            <div class="interval-5">
                <svg class="icon"
                    [class.loading]="data.execStatus === taskStatus.running || data.execStatus === taskStatus.rollbacking">
                    <use [attr.xlink:href]="str.icon[data.execStatus]"></use>
                </svg>
                <span *ngIf="data.execStatus === taskStatus.failed || data.execStatus === taskStatus.rollbackFailed"
                    class="linkText"
                    (click)="onShowErrorDetail(data)"
                    [innerHTML]="str.statusText[data.execStatus]">
                </span>
                <span *ngIf="!(data.execStatus === taskStatus.failed || data.execStatus === taskStatus.rollbackFailed)"
                    [innerHTML]="str.statusText[data.execStatus]">
                </span>
            </div>
        </ng-template>
    </n-data-table>
    <n-footer>
        <div class="slide-botton-group">
            <button pButton
                id="tasks_detail_close_button"
                type="button"
                (click)="close()"
                [label]="i18nLabel.closeBtn">
            </button>
        </div>
    </n-footer>
</n-slide-window>
<app-task-error-detail *ngIf="errorData"
    [(show)]="showErrorDetail"
    [error]="errorData">
</app-task-error-detail>
